<div
  class="message-container"
  wilsonTimerLine
  [duration]="duration"
  [lineElement]="lineElement"
>
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div class="hover-area" [class.without-icon-hover-area]="!showIcon"></div>
  <div class="line" [class.without-icon-line]="!showIcon" #lineElement></div>
</div>
